/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import styled from 'styled-components'
import ResponsiveFonts from '../../../components/layout_micro/responsiveFonts'
import Card from './card'
import useWidth from '../../../../hooks/useWidth'
import { Box, ButtonBase, Grid, Hidden, IconButton, useMediaQuery } from '@material-ui/core'
import ContainerSecondary from '../containerSecondary'
import CardMobileWraper from './CardMobileWrapper'
import { Email, Phone, WhatsApp } from '@material-ui/icons'
import auto from '../../../../assets/icono-autotoma-blanco.svg'
import autoGris from '../../../../assets/icono-autotoma-gris.svg'
import domicilioSrc from '../../../../assets/icono-domicilio-blanco.svg'
import domicilioGris from '../../../../assets/icono-domicilio-gris.svg'
import empresassrc from '../../../../assets/icono-empresas-blanco.svg'
import empresasGris from '../../../../assets/icono-empresas-gris.svg'
import { useHistory } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'

const Title = styled.div`
  font-size: 3em;
  font-family: 'imlbold'; font-weight: bold;
  color: var(--first);
  text-align: center;
  margin: 1.8em auto;
  line-height: 1em;
  box-sizing: border-box;
  @media screen and (max-width:600px) {
    margin: .7em auto;
  }
`
const ListServices = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
const BoxWrapper = styled.div`
  width: 33.3%;
  cursor: pointer;
`

const TextWrapper = styled.div`
  margin: 2em auto;
  color: var(--first);
`

const SubTitle = styled.div`
  font-size: 1.4em;
  font-family: 'imlbold'; font-weight: bold;
`
const Message = styled.div`
  font-size: 1.3em;
  line-height: 1.3em;
  font-family: 'imlregular';
  margin-top: 1em;
`
const Button = styled(ButtonBase)`
  padding: .9em 1.5em;
  font-size: 1.2em;
  text-transform: uppercase;
  border-radius: 15px;
  background: var(--second);
  color: #fff;
  @media screen and (max-width:600px) {
    margin: auto;
    display: block;
    font-size: 1.4em;
  }
`
const Href = styled.a`
  color: var(--first);
  text-decoration: none;
`
const IconContact = styled(IconButton)`
  background: var(--second);
  padding: 8px;
  margin-right: 10px;
  svg {
    color: #fff;
    font-size: 20px;
  }
  :hover {
    background: var(--first);
  }
  @media screen and (max-width:600px) {
    padding: 5px;
    svg {
      font-size: 15px;
    }
  }
`
const ContactItem = styled(Grid)`
  font-size: 1.2em;
  cursor: pointer;
  font-family: 'imlbold'; font-weight: bold;
`

const Services = props => {
  const history = useHistory()
  const width = useWidth('box')
  const [selected, setSeleceted] = useState('autotoma')
  const isMobile = useMediaQuery('(max-width:600px)')

  const handleScroll = element => {
    try {
      window.scrollTo({ top: element.offsetTop - 100, behavior: 'smooth' })
    } catch (error) {
      console.log(error)
    }
  }

  const domicilio = (
    <Card
      image={selected === 'domicilio' ? domicilioSrc : domicilioGris}
      height={width - (Math.ceil(width / 9))}
      message='Toma a domicilio'
      selected={selected === 'domicilio'}
    />
  )

  const autotoma = (
    <Card
      image={selected === 'autotoma' ? auto : autoGris}
      height={width - (Math.ceil(width / 9))}
      message='Módulo de Atención Externa'
      selected={selected === 'autotoma'}
    />
  )

  const empresas = (
    <Card
      image={selected === 'empresas' ? empresassrc : empresasGris}
      height={width - (Math.ceil(width / 9))}
      message='Empresas'
      selected={selected === 'empresas'}
    />
  )

  return (
    <ResponsiveFonts>
      <ContainerSecondary id='services'>
        <Title>Conoce nuestros 3 servicios</Title>
        <Hidden smDown>
          <ListServices>
            <BoxWrapper onClick={() => setSeleceted('autotoma')} id='box'>
              {autotoma}
            </BoxWrapper>
            <BoxWrapper onClick={() => setSeleceted('domicilio')}>
              {domicilio}
            </BoxWrapper>
            <BoxWrapper onClick={() => setSeleceted('empresas')}>
              {empresas}
            </BoxWrapper>
          </ListServices>
        </Hidden>
        <Hidden mdUp>
          {selected === 'autotoma' && (
            <CardMobileWraper onNext={event => setSeleceted('domicilio')}>
              <div id='box'>
                {autotoma}
              </div>
            </CardMobileWraper>
          )}
          {selected === 'domicilio' && (
            <CardMobileWraper onNext={event => setSeleceted('empresas')} onBack={event => setSeleceted('autotoma')}>
              <div id='box'>
                {domicilio}
              </div>
            </CardMobileWraper>
          )}
          {selected === 'empresas' && (
            <CardMobileWraper onBack={event => setSeleceted('domicilio')}>
              <div id='box'>
                {empresas}
              </div>
            </CardMobileWraper>
          )}
        </Hidden>
        {selected === 'autotoma' && (
          <TextWrapper>
            <SubTitle>
              Agenda COVID 19 Módulo de Atención Externa
            </SubTitle>
            <Message>
              Si tienes necesidad de hacerte una prueba PCR COVID 19, implementamos toma de muestra
              desde su vehículo para disminuir el riesgo de contagio con otras personas.
            </Message>
            <Box mt={3}>
              <Button onClick={event => history.push('/appointment')} style={{ marginRight: '1em' }}>Agenda tu cita</Button>
              {/* <HashLink to='/appointment#indications' smooth scroll={handleScroll}><Button onClick={event => history.push('/appointment')}>Indicaciones para el dia de tu toma de muestra</Button></HashLink> */}
            </Box>
          </TextWrapper>
        )}
        {selected === 'domicilio' && (
          <TextWrapper>
            <SubTitle>
              Agenda COVID 19 Toma a Domicilio
            </SubTitle>
            <Message>
              Si tienes necesidad de hacerte una prueba PCR COVID 19 a domicilio, agenda directo en cualquiera de nuestras opciones.
            </Message>
            <Box mt={5}>
              <Grid container spacing={2}>
                <ContactItem xs={6} md={4}>
                  <Href href='tel:4422130809' target='_blank'>
                    <IconContact size='small'>
                      <Phone />
                    </IconContact>
                    Tel. 442 213 0898
                  </Href>
                </ContactItem>
                <ContactItem xs={6} md={4}>
                  <Href href='https://api.whatsapp.com/send?phone=5214428173500' target='_blank'>
                    <IconContact size='small'>
                      <WhatsApp />
                    </IconContact>
                    WhatsApp
                  </Href>
                </ContactItem>
              </Grid>
            </Box>
          </TextWrapper>
        )}
        {selected === 'empresas' && (
          <TextWrapper>
            <SubTitle>
              Agenda COVID 19 Empresas
            </SubTitle>
            <Message>
              Sabemos que un buen estado de salud de los trabajadores contribuye a incrementar el bienestar
              y la productividad de las empresas. Si tu empresa tiene la necesidad de hacer pruebas COVID 19,
              agenda directo en cualquiera de nuestras opciones.
            </Message>
            <Box mt={5}>
              <Grid container spacing={2}>
                <ContactItem xs={6} md={4}>
                  <Href href='tel:4422130809' target='_blank'>
                    <IconContact size='small'>
                      <Phone />
                    </IconContact>
                    Tel. 442 213 0898
                  </Href>
                </ContactItem>
                <ContactItem xs={6} md={3}>
                  <Href href='https://api.whatsapp.com/send?phone=5214426137391' target='_blank'>
                    <IconContact size='small'>
                      <WhatsApp />
                    </IconContact>
                    WhatsApp
                  </Href>
                </ContactItem>
                <ContactItem xs={12} md={5} style={{ marginTop: isMobile ? '20px' : '' }}>
                  <Href href='mailto:empresas@laboratoriosiml.com'>
                    <IconContact size='small'>
                      <Email />
                    </IconContact>
                    empresas@laboratoriosiml.com
                  </Href>
                </ContactItem>
              </Grid>
            </Box>
          </TextWrapper>
        )}
      </ContainerSecondary>
    </ResponsiveFonts>
  )
}

export default Services
